import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "mt-3 pt-2"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" Edit ");

import { ref, reactive } from "vue";
import { useMessage } from "naive-ui";
import { handleError } from "@/utils/errors";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { GroupModel, GroupValidator } from "@/schemes/group";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    group: null
  },
  emits: ["edited"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
        emit = _ref.emit;
    var props = __props;
    var messageAPI = useMessage();
    var LoaderState = LoaderStateEnum;
    var model = reactive(_objectSpread(_objectSpread({}, GroupModel), {}, {
      name: props.group.name,
      description: props.group.description || ""
    }));
    var rules = GroupValidator;
    var loader = ref(LoaderStateEnum.Idle);
    var error = ref("");
    var form = ref(null);

    var edit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$http$put, group;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (form.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return form.value.validate();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", false);

              case 10:
                loader.value = LoaderStateEnum.Loading;
                _context.prev = 11;
                _context.next = 14;
                return http.put("/groups/".concat(props.group.groupId), model);

              case 14:
                _yield$http$put = _context.sent;
                group = _yield$http$put.data;
                emit("edited", group, model);
                loader.value = LoaderStateEnum.Idle;
                messageAPI.success("The group has been updated");
                _context.next = 27;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](11);
                _context.next = 25;
                return handleError(_context.t1);

              case 25:
                error.value = _context.sent;
                loader.value = LoaderStateEnum.Failed;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7], [11, 21]]);
      }));

      return function edit() {
        return _ref2.apply(this, arguments);
      };
    }();

    expose({
      loader: loader,
      edit: edit
    });
    return function (_ctx, _cache) {
      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_form = _resolveComponent("n-form");

      return _openBlock(), _createBlock(_component_n_form, {
        ref_key: "form",
        ref: form,
        model: _unref(model),
        rules: _unref(rules)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_form_item, {
            path: "name",
            label: "Name"
          }, {
            default: _withCtx(function () {
              var _unref$name$find;

              return [_createVNode(_component_n_input, {
                maxlength: (_unref$name$find = _unref(rules).name.find(function (r) {
                  return !!r.max;
                })) === null || _unref$name$find === void 0 ? void 0 : _unref$name$find.max,
                "input-props": {
                  autocomplete: 'off'
                },
                "show-count": "",
                value: _unref(model).name,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(model).name = $event;
                }),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["maxlength", "value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "description",
            label: "Description"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                maxlength: _unref(rules).description.max,
                "input-props": {
                  autocomplete: 'off'
                },
                "show-count": "",
                value: _unref(model).description,
                "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(model).description = $event;
                }),
                type: "textarea",
                autosize: true,
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["maxlength", "value"])];
            }),
            _: 1
          }), _renderSlot(_ctx.$slots, "action", {
            loader: loader.value
          }, function () {
            return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_n_button, {
              type: "primary",
              loading: loader.value === _unref(LoaderState).Loading,
              onClick: edit
            }, {
              default: _withCtx(function () {
                return [_hoisted_2];
              }),
              _: 1
            }, 8, ["loading"])])];
          }), loader.value === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            type: "error",
            class: "white-space-pre-line",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(error.value), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 3
      }, 8, ["model", "rules"]);
    };
  }
});